const SECRET_KEY = 'vestibular_nixlabs_sso_security_key_2027';

async function getKey(usage: KeyUsage): Promise<CryptoKey> {
  const enc = new TextEncoder();
  return crypto.subtle.importKey(
    'raw',
    enc.encode(SECRET_KEY),
    { name: 'HMAC', hash: 'SHA-256' },
    false,
    [usage]
  );
}

function bufferToHex(buffer: ArrayBuffer): string {
  return Array.from(new Uint8Array(buffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}

function hexToBuffer(hex: string): ArrayBuffer {
  const bytes = new Uint8Array(hex.length / 2);
  for (let i = 0; i < hex.length; i += 2) {
    bytes[i / 2] = parseInt(hex.substring(i, i + 2), 16);
  }
  return bytes.buffer;
}

export async function signRedirect(targetPath: string): Promise<string> {
  const enc = new TextEncoder();
  const timestamp = Date.now();
  const payload = JSON.stringify({ target: targetPath, ts: timestamp });
  const key = await getKey('sign');
  const signature = await crypto.subtle.sign('HMAC', key, enc.encode(payload));
  const hexSig = bufferToHex(signature);
  const base64Payload = btoa(payload);
  return encodeURIComponent(`${base64Payload}.${hexSig}`);
}

export async function verifyAndExtractRedirect(token: string): Promise<string> {
  try {
    let decoded = token;
    try {
      decoded = decodeURIComponent(token);
    } catch {
      // keep raw token
    }

    if (decoded.startsWith('/') && !decoded.startsWith('//')) {
      return decoded;
    }

    const [base64Payload, hexSig] = decoded.split('.');
    if (!base64Payload || !hexSig) return '/triagem';

    const payloadStr = atob(base64Payload);
    const enc = new TextEncoder();
    const key = await getKey('verify');
    const isValid = await crypto.subtle.verify(
      'HMAC',
      key,
      hexToBuffer(hexSig),
      enc.encode(payloadStr)
    );

    if (!isValid) return '/triagem';
    const parsed = JSON.parse(payloadStr);
    
    // reject tokens older than 24 hours
    if (Date.now() - parsed.ts > 86400000) return '/triagem';
    const target = parsed.target;
    if (typeof target === 'string' && target.startsWith('/') && !target.startsWith('//')) {
      return target;
    }
    return '/triagem';
  } catch {
    return '/triagem';
  }
}
